import _ from 'lodash'
import readingTypes from './readingTypes'

export default ({
  data,
  name,
}) => (
  _.find(readingTypes(data), { name })
)
